import { render, staticRenderFns } from "./ItemScLMultiple_List.vue?vue&type=template&id=204c89f8"
import script from "./ItemScLMultiple_List.vue?vue&type=script&lang=js"
export * from "./ItemScLMultiple_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports